module.exports = __webpack_public_path__ + "static/media/firebase.926cf03f.svg";